module.exports = __webpack_public_path__ + "static/media/mute-volume.4993390d.svg";